// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-content[data-v-6c452d7d]{position:relative;height:calc(100% - 50px)}.main-info[data-v-6c452d7d]{height:100%;width:100%}", ""]);
// Exports
module.exports = exports;
